import ev from "../util/enumValue";

enum TransitionType {

    FADE = ev('FADE', 1),
    FADE_DOWN = ev('FADE_DOWN', 2),
    FADE_LEFT = ev('FADE_LEFT', 3),
    FADE_RIGHT = ev('FADE_RIGHT', 4),
    FADE_UP = ev('FADE_UP', 5),

    SLIDE_DOWN = ev('SLIDE_DOWN', 6),
    SLIDE_LEFT = ev('SLIDE_LEFT', 7),
    SLIDE_RIGHT = ev('SLIDE_RIGHT', 8),
    SLIDE_UP = ev('SLIDE_UP', 9),

    ZOOM = ev('ZOOM', 10),
    BOUNCE = ev('BOUNCE', 11),
}

export default TransitionType;
